module.exports = __webpack_public_path__ + "static/2-d3e57261a0d4637d639968ad780582c2.png";